import { render } from "./ShipperDetail.vue?vue&type=template&id=474beda2&scoped=true"
import script from "./ShipperDetail.vue?vue&type=script&lang=js"
export * from "./ShipperDetail.vue?vue&type=script&lang=js"

import "./ShipperDetail.vue?vue&type=style&index=0&id=474beda2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474beda2"]])

export default __exports__